import { BigDecimal, LogisticaTiposFormaPago } from "@pcgerente-node/pcg-comun";
import { logistica_GUIA, logistica_RANGO_SEGURO } from '@pcgerente-node/pcg-comun/dist/DTOs';


export class logisticaRangoSeguroViewModel extends logistica_RANGO_SEGURO{
    /**Para usar este método es necesario que se llene el los datos de CLIENTE.logistica_RANGO_SEGURO tanto en el remitente como en el destinatario*/
    public static ObtenerRangoSeguroAplicadoFromGuia(consulta:"existe", guia: logistica_GUIA): boolean
    public static ObtenerRangoSeguroAplicadoFromGuia(consulta:"porcentaje", guia: logistica_GUIA): BigDecimal
    public static ObtenerRangoSeguroAplicadoFromGuia(consulta:"existe"|"porcentaje", guia: logistica_GUIA){

        let rangosSeguro: logistica_RANGO_SEGURO[]
        //Solo si es flete al cobro se toma en cuenta el seguro del  
        if(guia.tipo === LogisticaTiposFormaPago.FleteCobro){
            rangosSeguro = (guia.CLIENTE_DESTINATARIO?.logistica_RANGO_SEGURO)??[]
        }else{
            rangosSeguro = (guia.CLIENTE_REMITENTE?.logistica_RANGO_SEGURO)??[]
        }

        const coincidencia = rangosSeguro.find((el) => {
            if(guia.total > el.desde && guia.total <= el.hasta){
                return el
            }
        })

        if(consulta === "existe"){
            return !!coincidencia
        } 
        if(consulta === "porcentaje"){
            return new BigDecimal(coincidencia?.porcentaje||0)
        }
    }
}